// Outlined SVG map of New York State.
// Uses authentic NY state geometry from SimpleMaps' public US SVG (Lambert Azimuthal Equal-area).
// License: free for commercial & personal use (https://simplemaps.com/resources/svg-license).
// Source bounding box: x=[822.17, 942.33] y=[92.77, 184.40] (120.16 x 91.63)
// Transform fits source into our 600x440 viewBox with padding.
//
// Scale ~3.9 keeps geographic proportions; the SVG includes Long Island, Manhattan,
// Staten Island, and other small islands captured by the Census-derived outline.

const NY_PATH = "m 913.50695,181.78154 -1.45595,2.03832 -0.38825,0.58238 1.8442,-2.6207 z m 13.39471,-4.75609 4.85316,-4.27078 0,-0.19413 -4.85316,4.46491 z m -12.71527,3.00895 0,-3.30014 -0.29119,1.74713 0.29119,1.55301 z m 22.51864,-15.5301 -1.16475,-0.29119 -0.19413,0.87357 1.35888,-0.58238 z m 2.62071,-1.74713 -0.0971,0.97063 0.19412,-0.58238 -0.0971,-0.38825 z m -2.71777,0.0971 -6.50323,6.01791 -9.9975,4.27078 -2.6207,2.23245 -0.19413,2.13539 -2.71777,2.23245 0.38826,2.9119 4.17371,-1.65008 6.11498,-4.95022 6.79441,-3.59133 10.2887,-9.70631 -7.27974,5.53259 -2.32951,0.97064 3.88252,-6.40617 z m 3.00896,-4.07665 0.38825,-0.58238 -1.16476,1.35888 0.77651,-0.7765 z m -109.09895,-3.59134 -1.55301,-0.19412 1.16476,1.55301 0.38825,-1.35889 z m 32.22496,-29.70131 0.19412,-1.0677 -0.7765,0.97064 0.58238,0.0971 z m 0.48531,-6.98855 -0.38825,0.19413 -0.48532,1.06769 0.87357,-1.26182 z m -41.0577,55.13186 0.67944,2.91189 5.14435,1.26182 29.50719,-8.05624 29.70131,-8.92981 5.43554,4.17372 1.06769,2.42658 6.3091,2.71776 0.19413,0.38826 1.65007,0.38825 1.74714,0.48531 10.19163,2.52365 -0.19413,-0.48532 0.87357,3.97959 1.94126,-0.48532 1.0677,-4.36784 0,-0.0971 -1.74714,-1.65007 2.52364,-3.10602 -1.16476,-1.45595 -3.68839,-14.26828 -0.19413,-0.97063 -0.48532,-0.29119 -0.29119,-4.27078 -0.29119,-4.65903 -0.29118,-5.04728 0,-0.29119 -0.19413,0.0971 -4.85316,-15.91835 -5.14434,-8.05624 -1.45595,-9.60924 -4.36784,-10.191633 -0.58238,0.29119 -20.28619,6.794418 -4.07665,4.367845 -4.56197,8.73568 0.19413,1.94126 -6.01791,9.12393 3.68839,1.26182 1.0677,6.89148 -4.27078,5.62967 -12.81233,7.76504 -2.42658,-0.97063 -9.51218,1.35889 -8.83275,5.33847 0.48532,2.81483 3.10602,2.71777 -1.74714,8.54155 -6.98854,8.1533 -0.0971,0.0971 z";

// Transform: fit source bbox into 600x440 viewBox with padding
// scale = 3.9, translate = (-3140.76, -320.50)
const TRANSFORM = "translate(-3140.76 -320.50) scale(3.9)";

export default function NYStateMap({ className = "", strokeWidth = 1.4 }) {
  return (
    <svg
      viewBox="0 0 600 440"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-label="Outline map of New York State"
      data-testid="ny-state-map-svg"
    >
      <g transform={TRANSFORM}>
        <path d={NY_PATH} vectorEffect="non-scaling-stroke" />
      </g>

      {/* NYC marker — overlay positioned over the southern Long Island area */}
      <g transform="translate(508, 372)" data-testid="map-nyc-marker">
        <circle cx="0" cy="0" r="6" fill="currentColor" stroke="none" />
        <circle cx="0" cy="0" r="12" fill="none" opacity="0.3" />
      </g>

      {/* Albany marker */}
      <circle cx="470" cy="262" r="3" fill="currentColor" stroke="none" opacity="0.75" />

      {/* Syracuse marker */}
      <circle cx="338" cy="220" r="2.5" fill="currentColor" stroke="none" opacity="0.6" />

      {/* Rochester marker */}
      <circle cx="240" cy="218" r="2.5" fill="currentColor" stroke="none" opacity="0.6" />

      {/* Buffalo marker (SW) */}
      <circle cx="150" cy="252" r="2.5" fill="currentColor" stroke="none" opacity="0.6" />
    </svg>
  );
}
